import { useBreakpoints, breakpointsTailwind } from "@vueuse/core"

const breakpoints = useBreakpoints(breakpointsTailwind)

export const useResponsive = () => {
    const isSmallMobile = breakpoints.smaller("sm")
    const isMobile = breakpoints.smaller("md")
    const isTablet = breakpoints.smaller("xl")
    return {
        isSmallMobile,
        isMobile,
        isTablet,
    }
}
